import { BimboxRuntimeUtil } from '@pkpmcloud/bimcloud-app-utils'
import EventBus from '@aecworks/event-bus'
import RuntimeUtils from 'common/js/runtimeUtils'

const envAttribute = {
  serviceVersion: '',
  viewerPathV5: '',
  hostName: '',
  applicationPath: '',
  serviceOrigin: '',
}
envAttribute.serviceVersion = 'v3'
envAttribute.hostName = ''
envAttribute.viewerPathV5 = '/bimviewer/viewer/v5'
envAttribute.applicationPath = '/devcenter/console'
envAttribute.serviceOrigin = `${RuntimeUtils.instance.getObvServiceProtocol()}//${RuntimeUtils.instance.getCloudServiceHostname()}`
BimboxRuntimeUtil.instance.init(envAttribute)
window.BimboxRuntimeUtil = BimboxRuntimeUtil
window.EventBus = EventBus



// WEBPACK FOOTER //
// ./src/setViewModelInit.js